import React from 'react'
import {Navigation, Pagination, Autoplay} from 'swiper';
import { NavLink } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';            
import 'swiper/css';
import './Hero.css';
const Hero = () => {
 
  return (
    <>
        <div className='hero_main_banner'></div>

        <div className="hero">
            <div className="hero_img">
            <Swiper
                  modules={[Navigation, Pagination, Autoplay]}
                  spaceBetween={5}
                  slidesPerView={2}
                  navigation
                  pagination={{clickable:true}}
                  autoplay={true}
                  onSlideChange={() => console.log('slide change')}
                  onSwiper={(swiper) => console.log(swiper)}
            >
                  <SwiperSlide className='slide'>
                    <NavLink to="/aktu-quantum-books"><img className='hero_img' src="image/hero/Qantum.webp"alt="aktu quantum books pdf download"/></NavLink>
                  </SwiperSlide>

                  <SwiperSlide className='slide'>
                    <NavLink to="/resume-maker-online"><img className='hero_img' src="image/Resume/resume_price_img.webp" alt="online resume maker"/></NavLink>
                  </SwiperSlide>

                  <SwiperSlide className='slide'>
                    <NavLink to="/handwritten-notes-pdf"><img className='hero_img' src="image/HandWritten/HNbanner.webp" alt="handwritten notes pdf"/></NavLink>
                  </SwiperSlide>

                  <SwiperSlide className='slide'>
                    <NavLink to="/Projects"><img className='hero_img' src="image/ProjectImg/project.webp" alt="project reports pdf download"/></NavLink>
                  </SwiperSlide>

                  <SwiperSlide className='slide'>
                    <NavLink to="/basic-interview-questions-and-answers"><img className='hero_img' src="image/Interview/common-job-interview-questions.webp" alt="interview questions with answers"/></NavLink>
                  </SwiperSlide>

                  <SwiperSlide className='slide'>
                    <NavLink to="/basic-interview-questions-and-answers"><img className='hero_img' src="image/Interview/cheat_sheets/git-commands.webp" alt="top common interview questions hr asked"/></NavLink>
                  </SwiperSlide>

            </Swiper>

            </div>
        </div>
    
        <div className='hero_banner'>

          <div className="hero_banner_left">
            
              <div className="static_text"><h1><span>0</span>PREP</h1></div>

              <div className='dynamic_text'>
                <ul>
                    <li><span><k>CH</k>EAT SHEET</span></li>
                    <li><span>ROAD<k>MA</k>PS</span></li>
                    <li><span>HA<k>ND</k>NOTES</span></li>
                    <li><span>RES<k>UME</k></span></li>
                    <li><span>P<k>AP</k>ERS</span></li>
                    <li><span><k>PRO</k>JECTS</span></li>

                </ul>

              </div>


          </div>


        </div>

    
    </>
  )
}

export default Hero